import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Cell from '../cell';

var getChecked = function getChecked(props, defaultChecked) {
  if (typeof props.checked !== 'undefined') {
    return props.checked;
  }

  if (typeof props.defaultChecked !== 'undefined') {
    return props.defaultChecked;
  }

  return defaultChecked;
};

var Radio = /*#__PURE__*/function (_PureComponent) {
  _inherits(Radio, _PureComponent);

  var _super = _createSuper(Radio);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      checked: getChecked(_this.props, false)
    };

    _this.onValueChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;
      var checked = _this.state.checked;

      if (disabled) {
        return;
      }

      var newChecked = !checked;

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: newChecked
        });
      }

      if (typeof onChange === 'function') {
        onChange(e);
      }
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          type = _this$props2.type,
          shape = _this$props2.shape,
          value = _this$props2.value,
          checked = _this$props2.checked,
          defaultChecked = _this$props2.defaultChecked,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          children = _this$props2.children,
          onChange = _this$props2.onChange,
          rest = _objectWithoutProperties(_this$props2, ["prefixCls", "className", "type", "shape", "value", "checked", "defaultChecked", "disabled", "id", "children", "onChange"]);

      var checkedState = this.state.checked;
      var cls = classnames(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--checked"), checkedState), _defineProperty(_classnames, "".concat(prefixCls, "--disabled"), disabled), _defineProperty(_classnames, "".concat(prefixCls, "--untext"), !children), _classnames));
      var inputRender = /*#__PURE__*/React.createElement("input", {
        id: id,
        type: "radio",
        className: "".concat(prefixCls, "__input"),
        value: value,
        disabled: disabled,
        checked: checkedState,
        onChange: this.onValueChange
      });
      var radioRender = /*#__PURE__*/React.createElement("span", _extends({
        className: cls
      }, rest), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "__widget")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "__inner")
      })), children && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "__text")
      }, children), inputRender);

      if (type === 'cell') {
        return /*#__PURE__*/React.createElement(Cell, _extends({
          disabled: disabled,
          className: className,
          onClick: function onClick() {}
        }, rest), radioRender);
      }

      if (type === 'button') {
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          disabled: disabled,
          className: cls
        }, rest), children, inputRender);
      }

      return radioRender;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('checked' in nextProps && nextProps.checked !== state.prevChecked) {
        return {
          checked: nextProps.checked,
          prevChecked: nextProps.checked
        };
      }

      return null;
    }
  }]);

  return Radio;
}(PureComponent);

Radio.Group = void 0;
Radio.defaultProps = {
  prefixCls: 'za-radio',
  disabled: false,
  shape: 'radius'
};
export { Radio as default };